import { render, staticRenderFns } from "./ShowCustomerDetails.vue?vue&type=template&id=789c887c&scoped=true&"
import script from "./ShowCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./ShowCustomerDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShowCustomerDetails.vue?vue&type=style&index=0&id=789c887c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789c887c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCheckbox,VIcon,VRow,VTextField})
